module.exports = __webpack_public_path__ + "static/media/kayan_no_bg.be30f240.png";